import { SimplePageHeader } from '@flexinet/ui-components';

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader title="Billing Providers" />
    );
};
